import Dispatcher from "../dispatcher";
import BookUtils from "../utils/book-utils";

export default {
  addHighlight(isbn, noteText) {
    Dispatcher.emit(Dispatcher.HIGHLIGHT_SELECTION, isbn, noteText);
  },

  addEmojiHighlight(isbn, emoji, marker) {
    Dispatcher.emit(Dispatcher.HIGHLIGHT_EMOJI_SELECTION, isbn, emoji, marker);
  },

  // remove a highlight by its id
  deleteHighlight(isbn, syncId) {
    Dispatcher.emit(Dispatcher.HIGHLIGHTS_DELETE, isbn, syncId);
  },

  updateHighlight(isbn, syncId, data) {
    Dispatcher.emit(Dispatcher.HIGHLIGHT_UPDATE, isbn, syncId, data);
  },

  addCurrentHighlight(markerId, noteText, callback) {
    /* TODO
    (function(bookhelper){
      bookhelper.viewer.Book.highlightCurrentSelection({
        markerId: (markerId || bookhelper.markers[0].globalId),
        noteText: noteText
      }, function(data){
        if (data.isSuccess()){
          var obj = Fraction.Helpers.getDataObject('CurrentBook_'+bookhelper.isbn);
          obj.highlights.push(data.data.highlight);
          bookhelper.highlights = obj.highlights;
          bookhelper.redraw();

          Fraction.Helpers.logNPSFeedbackEvent("highlights");

          callback(data.data.highlight);
        } else {
          this.notesDown = true;
          Fraction.Helpers.toast(i18n.t('reader.notebook.notes-highlights-error'), {type: "error", dismissable: true});
          bookhelper.triggerHighlightUpdates();
        }
      });
    })(this);
    */
  },

  resetHighlights(isbn) {
    if (isbn) {
      Dispatcher.emit(Dispatcher.RESET_HIGHLIGHTS, isbn);
      BookUtils.redrawHighlights(isbn);
    }
  }
};
